import React from 'react';
import { useScreenSize } from '@myosh/odin-components';
import clsx from 'clsx';
import { isOfflineEnabled } from '../../../db/odin-db-util';
import { useOnlineStatus } from '../../../hooks/use-online-status';
import BackgroundJobPanel from '../../background-job-panel/background-job-panel.component';
import GlobalHierarchiesFilter from '../../dynamic-page/global-hierarchies-filter.component';
import GlobalSearchInput from './global-search/global-search-input.component';
import ProfileMenu from './profile-menu.component';

function OdinHeader() {
  const { isMobile } = useScreenSize();
  const isOnline = useOnlineStatus();

  const headerStyling = clsx('flex items-center w-full h-10 bg-primary-3', {
    'justify-between': !isMobile,
    'justify-end': isMobile,
  });

  return (
    // z-index set higher than other elements with z-index like nav, record and grid, to ensure header child components stay above other ui elements
    <header className="flex flex-col text-sm text-mono-1 shadow-md col-span-full row-start-1 z-[10000]">
      <div className={headerStyling}>
        <div className="flex h-full flex-1 items-center gap-2 md:flex-none">
          {!isMobile && <GlobalHierarchiesFilter />}
          <div className="min-w-0 flex-1">
            <GlobalSearchInput />
          </div>
        </div>
        <div className="col-start-5 flex h-full items-center justify-self-end">
          <BackgroundJobPanel />
          <ProfileMenu />
        </div>
      </div>
      {isOfflineEnabled && !isOnline && <div className="flex h-1 w-full bg-gray-2" />}
    </header>
  );
}

export default OdinHeader;
